
// 正面
import pectoralis_major_left_weak from '../../../assets/images/muscle/front/pectoralis_major_left_weak.png'
import pectoralis_major_right_weak from '../../../assets/images/muscle/front/pectoralis_major_right_weak.png'
import rectus_femoris_left_weak from '../../../assets/images/muscle/front/rectus_femoris_left_weak.png'
import rectus_femoris_right_weak from '../../../assets/images/muscle/front/rectus_femoris_right_weak.png'
import pectineus_left_tension from '../../../assets/images/muscle/front/pectineus_left_tension.png'
import pectineus_right_tension from '../../../assets/images/muscle/front/pectineus_right_tension.png'
import iliopsoas_left_weak from '../../../assets/images/muscle/front/iliopsoas_left_weak.png'
import iliopsoas_right_weak from '../../../assets/images/muscle/front/iliopsoas_right_weak.png'
import iliopsoas_left_tension from '../../../assets/images/muscle/front/iliopsoas_left_tension.png'
import iliopsoas_right_tension from '../../../assets/images/muscle/front/iliopsoas_right_tension.png'
import rectus_abdominis_weak from '../../../assets/images/muscle/front/rectus_abdominis_weak.png'

// 侧面
import scalene_tension from '../../../assets/images/muscle/side/scalene_tension.png'
import scalene_weak from '../../../assets/images/muscle/side/scalene_weak.png'
import sternocleidomastoid_tension from '../../../assets/images/muscle/side/sternocleidomastoid_tension.png'

// 背面
import trapezius_left_tension from '../../../assets/images/muscle/back/trapezius_left_tension.png'
import trapezius_right_tension from '../../../assets/images/muscle/back/trapezius_right_tension.png'
import trapezius_right_weak from '../../../assets/images/muscle/back/trapezius_right_weak.png'
import trapezius_left_weak from '../../../assets/images/muscle/back/trapezius_left_weak.png'
import gluteus_maximus_right_weak from '../../../assets/images/muscle/back/gluteus_maximus_right_weak.png'
import gluteus_maximus_left_weak from '../../../assets/images/muscle/back/gluteus_maximus_left_weak.png'
import soleus_left_tension from '../../../assets/images/muscle/back/soleus_left_tension.png'
import soleus_right_tension from '../../../assets/images/muscle/back/soleus_right_tension.png'
import semitendinosus_left_tension from '../../../assets/images/muscle/back/semitendinosus_left_tension.png'
import semitendinosus_right_tension from '../../../assets/images/muscle/back/semitendinosus_right_tension.png'
import semitendinosus_right_weak from '../../../assets/images/muscle/back/semitendinosus_right_weak.png'
import semitendinosus_left_weak from '../../../assets/images/muscle/back/semitendinosus_left_weak.png'
import plantar_fascia_left_tension from '../../../assets/images/muscle/back/plantar_fascia_left_tension.png'
import plantar_fascia_right_tension from '../../../assets/images/muscle/back/plantar_fascia_right_tension.png'
import levator_scapulae_left_tension from '../../../assets/images/muscle/back/levator_scapulae_left_tension.png'
import levator_scapulae_right_tension from '../../../assets/images/muscle/back/levator_scapulae_right_tension.png'
import biceps_femoris_long_left_tension from '../../../assets/images/muscle/back/biceps_femoris_long_left_tension.png'
import biceps_femoris_long_right_tension from '../../../assets/images/muscle/back/biceps_femoris_long_right_tension.png'
import biceps_femoris_long_right_weak from '../../../assets/images/muscle/back/biceps_femoris_long_right_weak.png'
import biceps_femoris_long_left_weak from '../../../assets/images/muscle/back/biceps_femoris_long_left_weak.png'


export const muscle_frontArg = [
    {
        key: 'pectoralis_major',
        scalex: 0.25,
        scaley: 0.1,
        offsetx: 1,
        offsety: 1.8,
        url: pectoralis_major_left_weak,
        status: "Weak"
    }, 
    {
        key: 'pectoralis_major',
        scalex: 0.25,
        scaley: 0.1,
        offsetx: 2,
        offsety: 1.8,
        url: pectoralis_major_right_weak,
        status: "Weak"
    }, 
    {
        key: 'rectus_femoris',
        scalex: 0.16,
        scaley: 0.2,
        offsetx: 1.4,
        offsety: 2.3,
        url: rectus_femoris_left_weak,
        status: "Weak"
    }, 
    {
        key: 'rectus_femoris',
        scalex: 0.16,
        scaley: 0.2,
        offsetx: 3.8,
        offsety: 2.3,
        url: rectus_femoris_right_weak,
        status: "Weak"
    }, 
    {
        key: 'pectineus',
        scalex: 0.13,
        scaley: 0.2,
        offsetx: 2.7,
        offsety: 2.3,
        url: pectineus_left_tension,
        status: "Tension"
    }, 
    {
        key: 'pectineus',
        scalex: 0.13,
        scaley: 0.2,
        offsetx: 3.9,
        offsety: 2.3,
        url: pectineus_right_tension,
        status: "Tension"
    },
    {
        key: 'iliopsoas',
        scalex: 0.1,
        scaley: 0.13,
        offsetx: 2.3,
        offsety: 3.3,
        url: iliopsoas_left_weak,
        status: "Weak"
    },  
    {
        key: 'iliopsoas',
        scalex: 0.1,
        scaley: 0.13,
        offsetx: 6.6,
        offsety: 3.3,
        url: iliopsoas_right_weak,
        status: "Weak"
    },  
    {
        key: 'iliopsoas',
        scalex: 0.1,
        scaley: 0.13,
        offsetx: 2.3,
        offsety: 3.3,
        url: iliopsoas_left_tension,
        status: "Tension"
    },  
    {
        key: 'iliopsoas',
        scalex: 0.1,
        scaley: 0.13,
        offsetx: 6.6,
        offsety: 3.3,
        url: iliopsoas_right_tension,
        status: "Tension"
    },  
    {
        key: 'rectus_abdominis',
        scalex: 0.26,
        scaley: 0.25,
        offsetx: 1.4,
        offsety: 1.1,
        url: rectus_abdominis_weak,
        status: "Weak"
    },  
    
]


export const muscle_sideArg = [
    {
        key: 'scalene',
        scalex: 0.13,
        scaley: 0.07,
        offsetx: 2.8,
        offsety: 1.6,
        url: scalene_tension,
        status: "Tension"
    }, 
    {
        key: 'scalene',
        scalex: 0.13,
        scaley: 0.07,
        offsetx: 2.8,
        offsety: 1.6,
        url: scalene_weak,
        status: "Weak"
    }, 
    {
        key: 'sternocleidomastoid',
        scalex: 0.13,
        scaley: 0.07,
        offsetx: 2.8,
        offsety: 1.6,
        url: sternocleidomastoid_tension,
        status: "Tension"
    }, 
    
];


export const muscle_backArg = [
    {
        key: 'trapezius',
        scalex: 0.21,
        scaley: 0.08,
        offsetx: 1.3,
        offsety: 1.9,
        url: trapezius_left_tension,
        status: "Tension"
    }, 
    {
        key: 'trapezius',
        scalex: 0.21,
        scaley: 0.08,
        offsetx: 2.5,
        offsety: 1.9,
        url: trapezius_right_tension,
        status: "Tension"
    }, 
    {
        key: 'trapezius',
        scalex: 0.21,
        scaley: 0.16,
        offsetx: 1.3,
        offsety: 1,
        url: trapezius_left_weak,
        status: "Tension"
    }, 
    {
        key: 'trapezius',
        scalex: 0.21,
        scaley: 0.16,
        offsetx: 2.5,
        offsety: 1,
        url: trapezius_right_weak,
        status: "Tension"
    }, 
    {
        key: 'gluteus_maximus', 
        scalex: 0.17,
        scaley: 0.08,
        offsetx: 1.8,
        offsety: 5.8,
        url: gluteus_maximus_left_weak,
        status: "Weak"
    }, 
    {
        key: 'gluteus_maximus', 
        scalex: 0.17,
        scaley: 0.08,
        offsetx: 3.1,
        offsety: 5.8,
        url: gluteus_maximus_right_weak,
        status: "Weak"
    }, 
    {
        key: 'gluteus_maximus', 
        scalex: 0.17,
        scaley: 0.08,
        offsetx: 1.8,
        offsety: 5.8,
        url: gluteus_maximus_left_weak,
        status: "Tension"
    }, 
    {
        key: 'gluteus_maximus', 
        scalex: 0.17,
        scaley: 0.08,
        offsetx: 3.1,
        offsety: 5.8,
        url: gluteus_maximus_right_weak,
        status: "Tension"
    }, 
    {
        key: 'soleus', 
        scalex: 0.18,
        scaley: 0.12,
        offsetx: 1.2,
        offsety: 5.9,
        url: soleus_left_tension,
        status: "Tension"
    }, 
    {
        key: 'soleus', 
        scalex: 0.18,
        scaley: 0.12,
        offsetx: 3.4,
        offsety: 5.9,
        url: soleus_right_tension,
        status: "Tension"
    }, 
    {
        key: 'semitendinosus',
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 2.1,
        offsety: 3.5,
        url: semitendinosus_left_weak,
        status: "Tension"
    }, 
    {
        key: 'semitendinosus',
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 5.2,
        offsety: 3.5,
        url: semitendinosus_right_weak,
        status: "Tension"
    }, 
    {
        key: 'semitendinosus',
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 2.1,
        offsety: 3.5,
        url: semitendinosus_left_weak,
        status: "Weak"
    }, 
    {
        key: 'semitendinosus',
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 5.2,
        offsety: 3.5,
        url: semitendinosus_right_weak,
        status: "Weak"
    }, 
    {
        key: 'plantar_fascia', 
        scalex: 0.14,
        scaley: 0.015,
        offsetx: 1.3,
        offsety: 64,
        url: plantar_fascia_left_tension,
        status: "Tension"
    }, 
    {
        key: 'plantar_fascia', 
        scalex: 0.14,
        scaley: 0.015,
        offsetx: 4.8,
        offsety: 64,
        url: plantar_fascia_right_tension,
        status: "Tension"
    }, 
    {
        key: 'levator_scapulae', 
        scalex: 0.1,
        scaley: 0.06,
        offsetx: 3.9,
        offsety: 1.6,
        url: levator_scapulae_left_tension,
        status: "Tension"
    }, 
    {
        key: 'levator_scapulae', 
        scalex: 0.1,
        scaley: 0.06,
        offsetx: 5.1,
        offsety: 1.6,
        url: levator_scapulae_right_tension,
        status: "Tension"
    }, 
    {
        key: 'biceps_femoris_long',
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 2.1,
        offsety: 3.5,
        url: biceps_femoris_long_left_tension,
        status: "Tension"
    }, 
    {
        key: 'biceps_femoris_long', 
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 5.2,
        offsety: 3.5,
        url: biceps_femoris_long_right_tension,
        status: "Tension"
    }, 
    {
        key: 'biceps_femoris_long',
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 2.1,
        offsety: 3.5,
        url: biceps_femoris_long_left_weak,
        status: "Weak"
    }, 
    {
        key: 'biceps_femoris_long', 
        scalex: 0.12,
        scaley: 0.16,
        offsetx: 5.2,
        offsety: 3.5,
        url: biceps_femoris_long_right_weak,
        status: "Weak"
    }, 
]

export function drawMuscle (imgUrl, data, canvasId) {

    let canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    let ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    let img = new Image();
    img.setAttribute('crossOrigin', 'Anonymous');
    img.src = imgUrl;
    img.onload = () => {

        let canvasClient = canvas.getBoundingClientRect();
        let scaleX = canvasClient.width / img.width;
        let scaleY = canvasClient.height / img.height;
        
        canvas.style.width = canvasClient.width + 'px';
        canvas.style.height = canvasClient.height + 'px';
        canvas.width = canvasClient.width;
        canvas.height = canvasClient.height;
        
        //画背景图
        ctx.drawImage(img, 0, 0, img.width * scaleX, img.height * scaleY)
        data.forEach((item) => {
            let img_s = new Image();
            img_s.src = item.url;
            img_s.onload = () => {

                let scaleX_s = canvas.width / img_s.width;
                let scaleY_s = canvas.height / img_s.height;
                let sx = item.scalex;
                let sy = item.scaley;
                let ox = item.offsetx;
                let oy = item.offsety;

                ctx.save()
                ctx.scale(sx, sy)
                ctx.drawImage(img_s, 
                    canvas.width * ox, canvas.height * oy,
                    img_s.width * scaleX_s, img_s.height * scaleY_s);
                ctx.restore()
            }
        })
    
    }

}
